// Scheduled-update notice (Ajustes → Actualización, server/runtime/update-notice.js). Every
// account sees it once: on entering, or within seconds if already inside (UpdateWatch reports
// the notice in force). «Entendido» records it on the server, so no other device shows it again.
const UpdateNotice = {
    handled: new Set(),
    open: false,

    formatDate(date) {
        return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },

    formatTime(date) {
        return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },

    /** Called with the id of the notice in force; asks the server only once per notice and session. */
    async consider(id) {
        const auth = window.AuthManager;
        if (!id || this.open || !auth?.isLoggedIn?.()) return;
        const key = `${auth._epoch}:${id}`;
        if (this.handled.has(key)) return;
        this.handled.add(key);
        try {
            const response = await fetch('/api/update-notice', { cache: 'no-store' });
            const body = await response.json();
            if (response.ok && body.notice && !body.seen) this.show(body.notice);
        } catch (e) {
            this.handled.delete(key);
        }
    },

    show(notice) {
        const at = new Date(notice.scheduledAt);
        const overlay = document.createElement('div');
        overlay.className = 'dnr-proposal update-overlay update-overlay--notice';
        overlay.setAttribute('role', 'alertdialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'update-notice-title');
        overlay.setAttribute('aria-describedby', 'update-notice-text');
        const card = document.createElement('div');
        card.className = 'update-overlay__card';
        const icon = document.createElement('div');
        icon.className = 'update-overlay__icon';
        icon.setAttribute('aria-hidden', 'true');
        const bell = document.createElement('i');
        bell.className = 'fas fa-clock-rotate-left';
        icon.append(bell);
        const eyebrow = document.createElement('p');
        eyebrow.className = 'update-overlay__eyebrow';
        eyebrow.textContent = 'Aviso';
        const title = document.createElement('h1');
        title.id = 'update-notice-title';
        title.textContent = 'Actualización programada';
        const text = document.createElement('p');
        text.id = 'update-notice-text';
        text.className = 'update-overlay__text';
        text.textContent = `El ${this.formatDate(at)} a las ${this.formatTime(at)} se actualizará SICAF. No estará disponible durante unos minutos.`;
        card.append(icon, eyebrow, title, text);
        if (notice.note) {
            const note = document.createElement('p');
            note.className = 'update-overlay__note';
            note.textContent = notice.note;
            card.append(note);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn btn-primary update-overlay__ok';
        button.textContent = 'Entendido';
        button.addEventListener('click', () => this.acknowledge(notice.id, overlay));
        card.append(button);
        overlay.append(card);
        document.body.append(overlay);
        this.open = true;
        button.focus();
    },

    async acknowledge(id, overlay) {
        overlay.remove();
        this.open = false;
        try {
            await fetch(`/api/update-notice/${encodeURIComponent(id)}/seen`, { method: 'POST' });
        } catch (e) {
            // Not recorded: it shows once more next time; this page never shows it again.
        }
    }
};

window.UpdateNotice = UpdateNotice;
